export default __webpack_public_path__ + "static/media/clientPageImage.b06be2b2.png";